import { useState, useEffect } from "react";

export default function useConsent() {

  const [consent, setConsent] = useState(null);

  useEffect(() => {
    const stored = localStorage.getItem("cookie_consent");
    if (stored) setConsent(JSON.parse(stored));
  }, []);

  function accept() {
    const data = {
      accepted: true,
      timestamp: Date.now(),
    };
    localStorage.setItem("cookie_consent", JSON.stringify(data));
    setConsent(data);
  }

  return { consent, accept };
}